import React from 'react';

export default function ConsentCard({ onConsent, disabled }) {
  return (
    <div className="sa-consent-card">
      <h2 className="section-title" style={{ marginBottom: 'var(--space-3)' }}>
        Prima di iniziare
      </h2>
      <p style={{ color: 'var(--color-ink-muted)' }}>
        Le informazioni raccolte servono ad aggiornare il tuo profilo presso
        ISA Digital Consulting e a valutarne la coerenza con le opportunità
        disponibili. La compilazione richiede pochi minuti e puoi
        interromperla in qualsiasi momento: le risposte già inviate restano
        salvate.
      </p>
      <div className="sa-consent-actions">
        <button type="button" className="btn btn-primary" disabled={disabled} onClick={() => onConsent(true)}>
          Acconsento e inizio
        </button>
        <button type="button" className="btn btn-secondary" disabled={disabled} onClick={() => onConsent(false)}>
          Non ora
        </button>
      </div>
    </div>
  );
}
